<div class="vehicle-side-list">
  <div class="content row m-0">
    <div class="col-7 vehicles">
      <!-- Add New Vehicle -->
      <div class="ui-g-12 add-vehicle p-0">
        <button id="vehicle-update-btn-add" type="button" (click)="onAddVehicle()"
          class="btn btn-primary btn-add-vehicle">
          <i class="fas fa-plus"></i>
          Vehicle
        </button>
      </div>

      <div class="ui-g-12 p-0 vehicle-list" (scroll)="onScroll($event)">
        <div #vehiclesList>
          <app-vechicle-item *ngFor="let vehicle of _vehicles; let i = index"
            [isTireStorageEnabled]="isTireStorageEnabled" [isMotorLookupEnabled]="isMotorLookupEnabled"
            [isCarfaxEnabled]="isCarfaxEnabled" [vehicleSearchPlaceholder]="vehicleSearchPlaceholder" [index]="i"
            [defaultMileageUnit]="defaultMileageUnit" [defaultRegState]="defaultRegState"
            [defaultRegStateCode]="defaultRegStateCode" [drivers]="drivers"
            [vehicleOdmHistory]="vehicleOdmHistory[vehicle._id] || []" [highLightedVehicleId]="highLightedVehicleId"
            [openConnectMotor]="openConnectMotor" [highLightedMiles]="highLightedMiles" [vehicleList]="_vehicles"
            [highLightedVIN]="highLightedVIN" [driveTypes]="driveTypes" [vehicleTags]="vehicleTags"
            [vehicleColors]="vehicleColors" [customerId]="customer?._id" [isFleetCustomer]="customer?.isFleetCustomer"
            [customer]="customer" [vehicle]="vehicle" (updateTagList)="updateTagList.emit($event)"
            (updateTags)="_updateTags($event)" (updateVehicleConnectedStatus)="_updateVehicleConnectedStatus()"
            (vehicleUpdate)="getVehicleUpdate($event)" (addTireStorageModal)="openAddTireStorageModal(vehicle)">
          </app-vechicle-item>
        </div>
      </div>

      <div [hidden]="!isVehiclesLoading" class="ui-g-12 flex-center-center mt-1 p-0 mb-5">
        <div class="fal fa-spinner font-21 rotate"></div>
      </div>
    </div>

    <div class="col-5 other">
      <app-upcoming-appointment [isLoadingAppointment]="isLoadingAppointment" [appointments]="customerAppointments"
        [user]="customer" [tab]="'vehicle tab'"></app-upcoming-appointment>
    </div>
  </div>
</div>
